import { Integer } from 'app/shared/domain/value-objects/integer';

export class SettingValue extends Integer {

}
